import { create } from "zustand";
import {
  WorkflowContainerCheckPointI,
  WorkflowContainerCheckPointActionI,
} from "../../../libs/interfaces";
// import { createJSONStorage, persist, StateStorage } from "zustand/middleware";
import { persist } from "zustand/middleware";
import { createWorkflowCheckpointSlice } from "./workflow-checkpoint.store";
// import { unifiedZustandStorage } from '../../../libs/helpers';
// const storage = unifiedZustandStorage;
// Custom storage object

export const useWorkflowCheckpointStore = create<
  WorkflowContainerCheckPointI & WorkflowContainerCheckPointActionI
>()(
  persist(
    (...a) => ({
      ...createWorkflowCheckpointSlice(...a),
    }),
    {
      name: "workflow-container-checkpoint-puce-1",
      // storage: createJSONStorage(() => storage),
    }
  )
);
